import { Link } from 'react-router-dom';
import { siteConfig, footerLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="px-4 md:px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-heading font-semibold mb-4 text-background-50/90">
                {group.title}
              </h4>
              <div className="w-8 h-px bg-background-50/20 mb-4"></div>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/60 hover:text-background-50/90 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 pt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="text-4xl md:text-5xl font-heading font-black text-background-50">
                {siteConfig.name}
              </span>
            </div>
            <div className="flex items-center gap-2 mt-2">
              <span className="w-6 h-px bg-background-50/30"></span>
              <span className="text-xs text-background-50/50">{siteConfig.tagline}</span>
            </div>
          </div>

          <div className="flex flex-col items-start sm:items-end gap-3">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-sm text-background-50/70"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-sm text-background-50/70"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors cursor-pointer"
                aria-label="抖音"
                rel="nofollow"
              >
                <i className="ri-tiktok-line text-sm text-background-50/70"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}